// extracted by mini-css-extract-plugin
export default {"wrapper":"languageSwitcher_wrapper__N6CwQ"};